import { render, staticRenderFns } from "./CreateEditPermissions.vue?vue&type=template&id=e5ca0d96&scoped=true"
import script from "./CreateEditPermissions.vue?vue&type=script&lang=js"
export * from "./CreateEditPermissions.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPermissions.vue?vue&type=style&index=0&id=e5ca0d96&prod&lang=scss&scoped=true"
import style1 from "./CreateEditPermissions.vue?vue&type=style&index=1&id=e5ca0d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ca0d96",
  null
  
)

export default component.exports